// extracted by mini-css-extract-plugin
module.exports = {"container":"Adyen_container__EPtsL","title":"Adyen_title__y_Ewh","infoText":"Adyen_infoText__fIF3u","loaderContainer":"Adyen_loaderContainer__Z73xp"};